<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Create Outbound Call</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2">
      <v-card
        class="pa-2 h-full"
        tile
      >
        <div v-if="me" :class="'w-full mb-3 p-3'">
            <div :class="'w-full mb-3 pt-2'">
                <p class="mb-1 text-xs mb-2"><strong>To Phone Number(s)</strong></p>

                <textarea v-model="phone_number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 200px;"
                    :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')" placeholder="e.g.
+8101245211
+8101245212
+8101245213"></textarea>

                <p class="text-xs text-gray-600 pt-2">
                    Enter the phone number(s) you'd like to call. You can enter multiple numbers, one per line.
                </p>
            </div>
            
            <p class="mb-1 text-xs mb-2"><strong>Call Prompt</strong></p>
            <textarea v-model="me.integrations.bland.settings[0].call_prompt" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 250px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"></textarea>

            <p class="text-xs text-gray-600 pt-2">
                Call prompt.
            </p>

            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4" :class="{'spinner': sendingCall}" @click="createOutboundCall();">
              CREATE CALL
            </button>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "AI Testing Suite | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      phone_number: "",
      sendingCall: false
    }
  },

  methods: {
    async createOutboundCall() {

      if (!this.phone_number) return;

      this.sendingCall = true

      let params = { api_key: this.me.integrations.bland.settings[0].api_key };

      params.area_code = this.area_code;

      params.From = this.me.integrations.bland.settings[0].phone_number;
      params.To = this.phone_number;
      params.call_prompt = this.me.integrations.bland.settings[0].call_prompt;

      await axios.post(`https://aiv2.revulsab.com/make-call`, params, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })
      this.sendingCall = false

      this.$swal({
          title: "Call(s) initiated!",
          text: "The calls have been successfully initiated.",
          showCancelButton: false,
      });
    },
  },

  created() {
    
  }
}
</script>